module.exports = __webpack_public_path__ + "static/media/connect.461c0ddc.png";